import { html } from 'lit';
import '../elements/d-label.js';
import { customElement, property } from 'lit/decorators.js';
import { DViewText } from 'src/library/fields/d-view-text';
import { LocalDate } from 'src/utilities/local-date';
import { relativeDaysAsText } from 'src/utilities/text';
import type { DateTimeFormat } from 'src/library/components/date-time-format';

/**
 *
 * STATUS OK
 */
@customElement('d-view-date')
export class DViewDate extends DViewText {
  @property({ type: String })
  format: DateTimeFormat = undefined;
  @property({ type: Object })
  today: LocalDate | undefined = undefined;
  @property({ type: Boolean })
  relative = false;
  private get formatted() {
    let result = '';
    if (this.value) {
      const date = LocalDate.fromString(this.value);
      if (!this.format || this.format === 'date-short') {
        result = date.toStringForDisplay();
      }
      if (this.format === 'date-monthName-year') {
        result = date.toStringForDisplayWithYear();
      }
      if (this.relative && this.today) {
        if (relativeDaysAsText(this.value, this.today)) {
          result += ' (' + relativeDaysAsText(this.value, this.today) + ')';
        }
      }
    }
    return result;
  }
  renderContent() {
    return html`
      <slot></slot>
      <slot name="under-label"></slot>
      <span class="content">${this.formatted}</span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-view-date': DViewDate;
  }
}
